import React, { useEffect, useState } from 'react';
import './ContactaScreen.css';
import { API_URL } from '../config';

export default function ContactaScreen({ userUid, token, onBack }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [terapeuta, setTerapeuta] = useState(null);

  useEffect(() => {
    async function fetchTerapeuta() {
      console.log('ContactaScreen debug:', { userUid, token });
  const url = `${API_URL}/usuarios/pacientes/${userUid}`;
      console.log('Consultando URL:', url);
      setLoading(true);
      setError('');
      try {
        // Nuevo endpoint: /usuarios/pacientes/:uid devuelve { neuro_email, neuro_telefono }
  const res = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.status === 401 || res.status === 403) {
          setError('Tu sesión expiró o el token es inválido. Por favor, vuelve a iniciar sesión.');
          setLoading(false);
          return;
        }
        if (res.status === 404) {
          setError('No se encontró el paciente. Verifica que tu cuenta esté correctamente asociada.');
          setLoading(false);
          return;
        }
        if (!res.ok) throw new Error('No se pudo obtener los datos del paciente');
        let text = await res.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch {
          console.error('Respuesta paciente no JSON:', text);
          throw new Error('Respuesta inesperada del servidor al buscar paciente.\n\nContenido devuelto:\n' + text.slice(0, 300));
        }
        if (!data.neuro_email || !data.neuro_telefono) throw new Error('No tienes terapeuta asignado');
        setTerapeuta({ email: data.neuro_email, telefono: data.neuro_telefono });
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
    if (userUid && token) fetchTerapeuta();
  }, [userUid, token]);

  if (!userUid || !token) {
    return (
      <div className="contacta-container">
        <h2>Contacta a tu Neuroterapeuta</h2>
        <div className="contacta-error">No se encontró tu usuario o sesión. Por favor, vuelve a iniciar sesión.</div>
        <button className="btn-regresar" onClick={onBack}>Regresar</button>
      </div>
    );
  }
  return (
    <div className="contacta-container">
      <h2>Contacta a tu Neuroterapeuta</h2>
      {loading && <div className="contacta-loading">Cargando datos del terapeuta...</div>}
      {error && <div className="contacta-error">{error}</div>}
      {terapeuta && (
        <div className="contacta-terapeuta">
          <div><strong>Email:</strong> <a href={`mailto:${terapeuta.email}`}>{terapeuta.email}</a></div>
          <div><strong>WhatsApp:</strong> <a href={`https://wa.me/${terapeuta.telefono.replace(/[^\\d]/g, '')}`} target="_blank" rel="noopener noreferrer">{terapeuta.telefono}</a></div>
        </div>
      )}
      <button className="btn-regresar" onClick={onBack}>Regresar</button>
    </div>
  );
}
